<template>
  <div class="w-full flex justify-between">
    <div class="px-1 lg:px-6 py-3 text-sm flex justify-between items-center w-full" :class="fontThin">
      <card-logo-and-numbers :card="card" />
      <span class="flex items-center justify-end w-16 lg:w-1/2" v-if="!expired">
        {{getFormattedMonth(card.exp_month)}}/{{card.exp_year}}
      </span>
      <span v-else class="flex items-center justify-end w-16 lg:w-1/2 text-b2c-red-300 font-bold text-xxs md:text-base">{{ $t('cards.expired') }}</span>
    </div>
    <button class="hover:text-b2c-red-300 w-3 px-4 md:px-6" @click="openAreYouSure" title="delete">
      <bin-icon />
    </button>
  </div>
</template>

<script>
import AreYouSureToDeleteCard from '@/components/graphics/AreYouSureToDeleteCard.vue';
import BinIcon from '@/components/graphics/BinIcon.vue';
import CardLogoAndNumbers from './CardLogoAndNumbers.vue';

export default {
  props: ['card'],

  data() {
    return {
      expired: false,
    };
  },

  components: {
    CardLogoAndNumbers,
    BinIcon,
  },

  created() {
    this.checkDate();
  },

  methods: {
    checkDate() {
      const now = new Date();
      const month = now.getMonth() + 1;
      const year = now.getFullYear();
      if (this.card.exp_year < year) {
        this.expired = true;
        return;
      }
      if (this.card.exp_year === year && this.card.exp_month < month) {
        this.expired = true;
      }
    },

    openAreYouSure() {
      this.$modal.show(AreYouSureToDeleteCard, { id: this.card.id }, { height: 'auto', adaptive: true });
    },

    getFormattedMonth(month) {
      if (month < 9) return `0${month}`;
      return month;
    },
  },

};
</script>
